import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\PricingController::calculate
* @see app/Http/Controllers/Api/PricingController.php:29
* @route '/api/pricing/calculate'
*/
export const calculate = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: calculate.url(options),
    method: 'post',
})

calculate.definition = {
    methods: ["post"],
    url: '/api/pricing/calculate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\PricingController::calculate
* @see app/Http/Controllers/Api/PricingController.php:29
* @route '/api/pricing/calculate'
*/
calculate.url = (options?: RouteQueryOptions) => {
    return calculate.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\PricingController::calculate
* @see app/Http/Controllers/Api/PricingController.php:29
* @route '/api/pricing/calculate'
*/
calculate.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: calculate.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\PricingController::current
* @see app/Http/Controllers/Api/PricingController.php:221
* @route '/api/pricing/current'
*/
export const current = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: current.url(options),
    method: 'get',
})

current.definition = {
    methods: ["get","head"],
    url: '/api/pricing/current',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\PricingController::current
* @see app/Http/Controllers/Api/PricingController.php:221
* @route '/api/pricing/current'
*/
current.url = (options?: RouteQueryOptions) => {
    return current.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\PricingController::current
* @see app/Http/Controllers/Api/PricingController.php:221
* @route '/api/pricing/current'
*/
current.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: current.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\PricingController::current
* @see app/Http/Controllers/Api/PricingController.php:221
* @route '/api/pricing/current'
*/
current.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: current.url(options),
    method: 'head',
})

const pricing = {
    calculate: Object.assign(calculate, calculate),
    current: Object.assign(current, current),
}

export default pricing